import { withTranslation } from 'react-i18next';
import { Route, Routes, useLocation } from 'react-router-dom';
import DoubleMatProgressWizard from '../../../../components/DoubleMat/DoubleMatProgressWizard';
import MaterialityAssessmentReport from '../../../SuperAdmin/MaterialityAssessment/MaterialityAssessmentReport/MaterialityAssessmentReport';
import MaterialIssuesTabs from './Issues/MaterialIssuesTabs';
import IssuesVersionsList from './IssuesVersionsList';
import MatAssessmentList from './MatAssessmentList';
import MatAssessmentSubmissionList from './MatAssessmentSubmissionList';
import MatReportList from './MatReportList';
import './MaterialityAssessment.scss';
import OverviewMateriality from './OverviewMateriality';
import ScoreCard from './ScoreCard';
import ScoreCardList from './ScoreCardList';
import ScorecardDefaultView from './ScorecardDefaultView';
import Stakeholders from './Stakeholders';
import StakeholdersDefaultView from './StakeholdersDefaultView';


const DoubleMatContainer = ({ t }) => {
	const location = useLocation();
	return (
		<div>
			{!location.pathname.endsWith('/stats') && !location.pathname.endsWith('/report') && <DoubleMatProgressWizard viewMode='DOUBLE_MAT_HEADER'/>}
			<Routes>
				<Route path="stakeholders" element={<Stakeholders />} />
				<Route path="stakeholders/list" element={<StakeholdersDefaultView />} />
				<Route path="issues" element={<MaterialIssuesTabs />} />
				<Route path="matassessments" element={<MatAssessmentList />} />
				<Route path="scorecard/default" element={<ScorecardDefaultView />} />
				<Route path="scorecard/list" element={<ScoreCardList />} />
				<Route path="report/list" element={<MatReportList />} />
				<Route path="stats" element={<OverviewMateriality />} />
				<Route path="report" element={<MaterialityAssessmentReport />} />
				<Route path="issues/versions" element={<IssuesVersionsList />} />
				<Route path="matassessments/:id/submissions/:self" element={<MatAssessmentSubmissionList />} />
				<Route path="scorecard" element={<ScoreCard />} />
			</Routes>
		</div>
	);
};
export default withTranslation()(DoubleMatContainer);